interface BrowserCompatibilityProps { onWebUsb: boolean; secure: boolean }

export function BrowserCompatibility({ onWebUsb, secure }: BrowserCompatibilityProps) {
  const browser = navigator.userAgent.includes("Edg/") ? "Microsoft Edge" : navigator.userAgent.includes("Chrome/") ? "Chrome" : "Trình duyệt hiện tại";
  return (
    <section className="compatibility" aria-label="Tương thích trình duyệt">
      <span className={onWebUsb ? "status-dot good" : "status-dot bad"} />
      <span><strong>WebUSB</strong> {onWebUsb ? "sẵn sàng" : "không được hỗ trợ"}</span>
      <span className={secure ? "pill good-pill" : "pill warn-pill"}>{secure ? "HTTPS / localhost" : "Không an toàn"}</span>
      <span className="muted">{browser}</span>
    </section>
  );
}
